import { AgreementObjectActions } from 'agreementObject/types/redux/agreementObjectActions';
import AgreementObjectState, {
    SelectedObjectIDSelector,
    SelectedStartDateForMultiAgreementSelector,
} from 'agreementObject/types/redux/AgreementObjectState';
import { AGREEMENT_OBJECT } from 'core/datasets/action';
import { AppState } from '../../core/redux/rootReducer';
import agreementSelectors from 'agreement/redux/agreementSelectors';
import { createSelector } from 'reselect';

const initialState: AgreementObjectState = {
    objects: null,
    selectedObjectID: null,
    selectedObject: null,
};

export const agreementObjectsReducer = (state = initialState, action: AgreementObjectActions): AgreementObjectState => {
    switch (action.type) {
        case AGREEMENT_OBJECT.PUT_AGREEMENT_OBJECTS: {
            return {
                ...state,
                objects: action.payload,
            };
        }
        case AGREEMENT_OBJECT.AGREEMENT_OBJECT_SELECTED: {
            const object = action.payload;
            return {
                ...state,
                selectedObjectID: object?.id || null,
                selectedObject: object,
            };
        }
        case AGREEMENT_OBJECT.AGREEMENT_OBJECT_SELECTED_BY_ID: {
            const agreementObjects = state.objects;
            const selectedObjectID = action.payload;
            const selectedObject = agreementObjects?.[selectedObjectID];

            if (selectedObject) {
                return {
                    ...state,
                    selectedObjectID: selectedObject?.id || null,
                    selectedObject: selectedObject,
                };
            }
            return state;
        }
        default:
            return state;
    }
};

const agreementObjectsSelector = (state: AppState) => state.agreementObjects;

export const selectedObjectIDSelector: SelectedObjectIDSelector = (state) =>
    agreementObjectsSelector(state).selectedObjectID;
export const selectedStartDateForMultiAgreementSelector: SelectedStartDateForMultiAgreementSelector = (state) =>
    agreementObjectsSelector(state).selectedObject?.agreement?.agreementStart;

export const selectedStartDateForAgreementSelector = (state: AppState) => {
    const agreementStart = agreementObjectsSelector(state).selectedObject?.agreement?.agreementStart;
    const agreementDate = agreementSelectors.selectedAgreement(state)?.agreementDate;

    return agreementStart ?? agreementDate;
};
export const selectedObjectSelector = (state: AppState) => agreementObjectsSelector(state).selectedObject;
export const smartHomeExternalId = (state: AppState) => selectedObjectSelector(state)?.smartHome?.external_id;
export const smartHomeOrganizationId = (state: AppState) => selectedObjectSelector(state)?.smartHome?.organization_id;

const selectedAgreementSelector = (state: AppState) => state.agreements.selectedAgreement;
const smartHomeSettingsSelector = createSelector(
    [selectedObjectSelector, selectedAgreementSelector],
    (selectedObject, selectedAgreement) => {
        if (
            !selectedObject?.smartHome ||
            !selectedObject?.smartHome?.isAvailable ||
            selectedObject.smartHome.type !== 'larva' ||
            !selectedObject?.smartHome.organization_id ||
            !selectedObject?.smartHome.external_id
        ) {
            return null;
        }

        if (!selectedAgreement) {
            console.error('No agreement selected');
            return null;
        }

        const { organization_id, external_id } = selectedObject.smartHome;

        return {
            orgId: organization_id,
            externalId: external_id,
            agreementUUID: selectedAgreement.uuid as string,
        };
    },
);

const hasSmartHome = createSelector(
    [selectedObjectSelector],
    (selectedObject) => selectedObject?.smartHome?.isAvailable ?? false,
);

export const agreementObjectsSelectors = {
    selectedObjectIDSelector,
    selectedStartDateForMultiAgreementSelector,
    selectedStartDateForAgreementSelector,
    smartHomeExternalId,
    smartHomeOrganizationId,
    selectedObjectSelector,
    smartHomeSettingsSelector,
    hasSmartHome,
};
